import { Data_getInstanceisjrughipj66 as Data_getInstance } from './adapter/SpinMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Companion_getInstance1m1mmkl5t8eg3 as Companion_getInstance } from './type/Mutation.mjs';
import { Builder320ghmibyd2no as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { SpinMutationSelections_getInstancexbsjnbe2vaza as SpinMutationSelections_getInstance } from './selections/SpinMutationSelections.mjs';
import { SpinMutation_VariablesAdapter_instance3okgxube6cxay as SpinMutation_VariablesAdapter_instance } from './adapter/SpinMutation_VariablesAdapter.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(spin) {
        this.f6i_1 = spin;
      }
      toString() {
        return 'Data(spin=' + this.f6i_1 + ')';
      }
      hashCode() {
        return this.f6i_1 == null ? 0 : getBooleanHashCode(this.f6i_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.f6i_1 == other.f6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.g6i_1 = obj(Data_getInstance());
        this.h6i_1 = (new (Builder())('data', Companion_getInstance().x6d_1)).t43(SpinMutationSelections_getInstance().k6i_1).j37();
        this.i6i_1 = '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
        this.j6i_1 = 'spin';
      }
      a6e() {
        return 'mutation spin($input: SpinInput!) { spin(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var SpinMutationClass;
function SpinMutation() {
  if (SpinMutationClass === VOID) {
    class $ {
      constructor(input) {
        Companion_getInstance_0();
        this.l6i_1 = input;
      }
      c6e() {
        return '9e9620cf6c68a6bcc9b17a91bc9bb717ac303825fa49b83e7b6138072b6a4df3';
      }
      operationId() {
        return this.c6e();
      }
      m47() {
        return Companion_getInstance_0().a6e();
      }
      d6e() {
        return 'spin';
      }
      operationName() {
        return this.d6e();
      }
      q46(writer, customScalarAdapters, withDefaultValues) {
        SpinMutation_VariablesAdapter_instance.m6i(writer, this, customScalarAdapters, withDefaultValues);
      }
      p46() {
        return Companion_getInstance_0().g6i_1;
      }
      toString() {
        return 'SpinMutation(input=' + this.l6i_1.toString() + ')';
      }
      hashCode() {
        return this.l6i_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SpinMutation()))
          return false;
        if (!this.l6i_1.equals(other.l6i_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SpinMutation', VOID, VOID, [Mutation()]);
    SpinMutationClass = $;
  }
  return SpinMutationClass;
}
//region block: exports
export {
  Data as Data17skrs4gatjls,
  SpinMutation as SpinMutation3rsfya4nf2aew,
};
//endregion

//# sourceMappingURL=SpinMutation.mjs.map
